import { qzTrayPreviewApi } from "../../api";

/**
 * 👁️ QzTrayPreviewService
 *
 * Gestiona la generación y obtención de la vista previa de tickets
 * antes de enviarlos a imprimir con QZ Tray.
 *
 * ✅ Funcionalidad principal:
 * - Obtener una vista previa de ejemplo (logo, texto, QR)
 * - Generar una vista previa real desde datos de venta
 */
const QzTrayPreviewService = {
  /**
   * 🎨 Obtener vista previa de ejemplo
   * GET /api/qztray/preview/sample
   */
  getSamplePreview: async () => {
    const response = await qzTrayPreviewApi.fetchCustom(`/sample`);
    return response.data;
  },

  /**
   * 🧾 Generar vista previa real desde datos enviados
   * POST /api/qztray/preview
   *
   * @param payload Datos base (por ejemplo, venta o documento)
   */
  generatePreview: async (payload: any) => {
    const response = await qzTrayPreviewApi.add(payload);
    return response.data;
  },
};

export default QzTrayPreviewService;
